import { Box } from "@mui/material";
import { OrganizationUserContext } from "contexts/Organization";
import { useContext, useEffect, useLayoutEffect, useRef } from "react";
import { Route, Routes } from "react-router-dom";

import { PAGE_VISITED } from "constants/trackingProps";
import AssistantCTA from "features/Home/Sidebar/AssistantPreview/AssistantCTA";
import { trackEvent } from "utils/tracking";

import OutreachTable from "./NewOutreachTable";

export default function InfluencerContacts() {
  const { currentOrg } = useContext(OrganizationUserContext);
  const wrapperRef = useRef<HTMLDivElement>(null);
  const alertsRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    trackEvent(PAGE_VISITED);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentOrg?.id]);

  // Publish the alerts block's rendered height as a CSS variable so the
  // inbox scroll regions can subtract it from their `calc(100vh - ...)`.
  useLayoutEffect(() => {
    const alertsEl = alertsRef.current;
    const wrapperEl = wrapperRef.current;
    if (!alertsEl || !wrapperEl) return;
    const update = () => {
      wrapperEl.style.setProperty(
        "--inbox-alerts-h",
        `${alertsEl.offsetHeight}px`,
      );
    };
    update();
    const observer = new ResizeObserver(update);
    observer.observe(alertsEl);
    return () => observer.disconnect();
  }, []);

  return (
    <Box ref={wrapperRef} sx={{ "--inbox-alerts-h": "0px" }}>
      <Box
        ref={alertsRef}
        sx={{ px: { xs: 1, sm: 2 }, pt: 2, "&:empty": { p: 0 } }}
      >
        <AssistantCTA
          title="Need help with your inbox?"
          body="Chat with AI for personalized suggestions on what to reply to first."
          openContext={{ promptPage: "inbox" }}
        />
      </Box>
      <Routes>
        <Route path="*" element={<OutreachTable />} />
      </Routes>
    </Box>
  );
}
